import { CHART_COLORS } from "app/constants/ChartColors";
import _ from "lodash";
import type { IChartData } from "../TrafficVolumesLineChart.types";
import { trafficSourcesForSegments } from "app/Shared/utils";
import type { IServices } from "../../common/useMarketingChannelsServices";
import dateTimeService from "app/services/date-time/dateTimeService";
import type { ApiOvertimeData } from "app/pages/industry-analysis/traffic-sources/MarketingChannels/TrafficShareBarChart/types";

export const adaptApiData = (data: ApiOvertimeData, services: IServices): IChartData[] => {
    if (!data) {return null;}

    const channelNames = Object.keys(data);

    return channelNames.map((channelName) => {
        const channelRecords = data[channelName];
        const color = CHART_COLORS.trafficSourcesColorsBySourceMMX[channelName];
        const trafficSource = trafficSourcesForSegments[channelName];
        const adaptedRecords = Object.keys(channelRecords).map((key) => {
            const x = dateTimeService.getUTCTimeStamp(key);
            const y = channelRecords[key];
            return { x, y };
        });
        const sortedRecords = _.sortBy(adaptedRecords, (point) => point.x);

        return {
            name: services.translate(trafficSource.title),
            color: color,
            data: sortedRecords,
            priority: trafficSource.priority,
        };
    });
};

export const sortChartData = (data: IChartData[]) => {
    if (!data || data.length <= 0) {return null;}
    return _.sortBy(data, (record) => record.priority);
};
